query ListEvents($mineOnly: Boolean) {
  events: StreamToolsListEvents(mineOnly: $mineOnly) {
    eventId
    slug
    name
    description
    status
    createdAt
    startedAt
    endedAt
  }
}
